/**
 * External dependencies
 */
import { registerPlugin } from '@wordpress/plugins';

const render = () => {};

registerPlugin('ka-mca-checkout-block', {
	render,
	scope: 'woocommerce-checkout',
});
